import { css } from '@emotion/core'
import styled from '@emotion/styled'
import {
  black,
  borderGray,
  marketingMobileCuttoff,
  radiantBlue,
  white,
  MQ, ipadproMax, imac13inMax,
} from '@css/constants'
import { FontNormal } from '@css/fonts'
import {Button} from "@components/Button";

type ProductCardSectionIconColProps = {
  imageUrl: string;
}

type LearnMoreButtonProps = {
  learnMoreUrl: string;
}

type ProductCardSectionTitleProps = {
  lessWidth: boolean;
  moreWidth: boolean;
}

export const ProductCardSectionContainer = styled.li`
  background: ${white};
  border: 1px solid ${borderGray};
  box-sizing: border-box;
  box-shadow: 0px 4px 12px rgba(26, 28, 31, 0.15);
  border-radius: 5px;
  height: 248px;
  width: 242px;
  flex-direction: column;
  display: flex;
  margin: 10px 10px;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin: 6px 0;
    height: 156px;
    width: 100%;
    max-width: 343px;
  }
`

export const ProductCardSectionIconCol = styled.div<ProductCardSectionIconColProps>`
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: auto;
  background-image: url(${props => props.imageUrl});
  position: relative;
  height: 80px;
  min-width: 60px;

  @media(max-width: ${marketingMobileCuttoff}) {
    height: 90px;
    min-width: 60px;
    margin-left: 20px;
  }
`

export const ProductCardSectionColumnFlex = styled.div`
  flex-direction: column;
  display: flex;
  padding-top: 10px;

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: row;
    padding-top: 0;
  }
`

export const ProductCardSectionTextColumn = styled.div`
  flex-direction: column;
  display: flex;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-left: 10px;
    margin-top: 24px;
    align-items: start;
  }
`

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: row-reverse;
    align-self: center;
    align-items: center;
    width: 100%;
    max-width: 343px;
    margin-bottom: 18px;
    padding-right: 5px;
  }

  ${MQ.SMALL_SCREENS} {
    max-height: 46px;
  }
`

export const ProductCardSectionRowFlex = styled.ul`
  flex-direction: row;
  display: flex;
  place-content: center;
  list-style: none;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: 1072px) {
    flex-flow: wrap;
  }

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
    margin: 10px 10px;
    align-items: center;
  }
`

export const ProductCardSectionTitle = styled.p<ProductCardSectionTitleProps>`
  max-width: ${props => props.lessWidth ? '35%': props.moreWidth ? '72%' : '100%'};
  display: flex;
  align-self: center;
  font-size: 16px;
  ${FontNormal(600)};
  text-align: center;
  color: ${black};

  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: start;
    max-width: 100%;
    align-self: start;
  }
`

export const ProductCardSectionSubtitle = styled(ProductCardSectionTitle)`
  color: ${radiantBlue};
  margin-bottom: 10px;

  & > sup {
    font-size: 10px;
    vertical-align: text-top;
  }

/*  @media(max-width: 960px) {
    font-size: 14px;
  }

  @media(max-width: 940px) {
    font-size: 13px;
  }*/

  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: start;
  }
`

export const getQuoteBtnStyles = css`
  padding: 16px 32px;

/*  @media(max-width: 940px) {
    padding: 16px 20px;
  }

  @media(max-width: 820px) {
    padding: 16px 14px;
  }*/

  ${MQ.SMALL_SCREENS} {
    padding: 13px 0;
    margin-right: 10px;
    max-height: 46px;
  }
`

export const learnMoreBtnStyles = css`
  padding: 16px 0;
  margin: 0px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    margin-left: 4px;
    width: 14px;
    height: 14px;
  }

  ${MQ.SMALL_SCREENS} {
    text-decoration: underline;
    margin-right: 10px;
    padding: 0;

    & > svg {
      display: none;
    }
  }
`

export const LearnMoreButton = styled(Button)<LearnMoreButtonProps>`
  visibility: ${props => props.learnMoreUrl ? 'visible':'hidden'};
`;

export const Divider = styled.div`
  display: flex;
  width: 1px;
  background-color: white;
  margin-bottom: 10px;
  margin-top: 10px;

  @media(min-width: 1046px) and (max-width: 1072px) {
    display: none;
  }
  
  @media(min-width: 770px) and (max-width: 785px) {
    display: none;
  }
  
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: 1072px) {
    background-color: ${borderGray};
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    background-color: ${borderGray};
    height: 1px;
    width: 85%;
  }
  
`;